import { useState, useEffect } from "react";
import { API, authFetch } from "../App";
import { toast } from "sonner";
import { FileText, Download, Clock, CheckCircle, ArrowRight, Upload } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function MyServices({ currentFY, onUpgrade }) {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("current");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const res = await authFetch(`${API}/payments/my-payments`);
        if (res.ok) {
          const data = await res.json();
          setPayments(data);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchPayments();
  }, []);

  if (loading) {
    return <div className="p-8 text-center"><div className="spinner mx-auto"></div></div>;
  }

  const currentServices = payments.filter(p => p.financial_year === currentFY);
  const pastServices = payments.filter(p => p.financial_year !== currentFY);

  const displayList = activeTab === "current" ? currentServices : pastServices;

  return (
    <div className="space-y-6">
      <div className="flex gap-4 border-b border-[var(--border-light)] pb-2">
        <button
          className={`pb-2 px-2 font-medium transition-colors ${activeTab === "current" ? "text-[var(--primary)] border-b-2 border-[var(--primary)]" : "text-[var(--text-muted)] hover:text-[var(--text-main)]"}`}
          onClick={() => setActiveTab("current")}
        >
          Current Services (FY {currentFY})
        </button>
        <button
          className={`pb-2 px-2 font-medium transition-colors ${activeTab === "past" ? "text-[var(--primary)] border-b-2 border-[var(--primary)]" : "text-[var(--text-muted)] hover:text-[var(--text-main)]"}`}
          onClick={() => setActiveTab("past")}
        >
          Past Services
        </button>
      </div>

      {displayList.length === 0 ? (
        <div className="text-center p-12 bg-white rounded-2xl border border-[var(--border-light)]">
          <FileText className="w-12 h-12 text-[var(--text-muted)] mx-auto mb-4 opacity-50" />
          <h3 className="text-lg font-bold text-[var(--text-main)] mb-2">No services found</h3>
          <p className="text-[var(--text-muted)]">You don't have any {activeTab} services.</p>
        </div>
      ) : (
        <div className="grid gap-4">
          {displayList.map(payment => (
            <div key={payment.payment_id} className="bg-white p-6 rounded-2xl border border-[var(--border-light)] shadow-sm flex flex-col md:flex-row gap-4 justify-between items-start md:items-center">
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-bold bg-[var(--primary)]/10 text-[var(--primary)] px-2 py-1 rounded">FY {payment.financial_year}</span>
                  <span className="text-xs font-bold bg-[var(--success)]/10 text-[var(--success)] px-2 py-1 rounded flex items-center gap-1">
                    <CheckCircle className="w-3 h-3" /> {payment.status}
                  </span>
                </div>
                <h3 className="font-bold text-lg text-[var(--text-main)]">
                  {payment.service_type === "both" ? "ITR Filing + Cloud Accounting" : 
                   payment.service_type === "accounting" ? "Cloud Accounting" : "ITR Filing"}
                </h3>
                <p className="text-[var(--text-muted)] text-sm mb-2">Payment ID: {payment.payment_id}</p>
                <div className="text-sm font-medium">Total Paid: {"\u20B9"}{payment.total_amount?.toLocaleString()}</div>
              </div>
              
              <div className="flex flex-col gap-2 w-full md:w-auto">
                {payment.receipt_url && (
                  <a href={payment.receipt_url} target="_blank" rel="noreferrer" className="soft-btn-outline !py-2 !px-4 text-sm flex items-center justify-center">
                    <Download className="w-4 h-4 mr-2" /> Download Invoice
                  </a>
                )}
                {activeTab === "current" && (
                  <button onClick={() => onUpgrade(payment)} className="soft-btn !py-2 !px-4 text-sm flex items-center justify-center">
                    <Upload className="w-4 h-4 mr-2" /> Upgrade / Add Info
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
